var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"memberpurchases"}},[_c('PurchasesList',{attrs:{"context":"member-purchases"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }